import {
  Button,
  Cascader,
  Collapse,
  Form,
  Input,
  InputNumber,
  Modal,
  Radio,
  Select,
  Switch,
  message,
} from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { IconFont, BasTitle } from '@/components'
import { useState, useEffect } from 'react'
import { useUpdateConfigSite, useGetCreateSiteSecurityDeviceList } from './utils'
import { useForm } from 'antd/es/form/Form'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { t } from '@/i18n'

export const DeviceConfigModal = props => {
  const { SHOW_CHILD } = Cascader
  const { id, onOk, onCancel } = props
  const [form] = useForm()
  const navigate = useNavigate()

  const [updateConfigSite] = useUpdateConfigSite()
  const [getCreateSiteSecurityDeviceList] = useGetCreateSiteSecurityDeviceList() // 创建站点安全设备列表
  const [deviceData, setDeviceData] = useState([]) //站点级联

  const [selectedDevices, setSelectedDevices] = useState<string[]>([])

  useEffect(() => {
    getCreateSiteSecurityDeviceList()
      .then(res => {
        const group = res.data.groups.map(item => {
          if (item.devices.length > 0) {
            return {
              device_type: item?.deviceType?.name,
              device_list: item?.devices?.map(device => ({
                device_brand: device?.deviceBrand?.name,
                device_name: device?.deviceName,
                device_ip: device?.deviceIp,
                device_id: device?.id,
                chainId: device?.chainId,
              })),
            }
          }
        })

        console.log('group', group)

        setDeviceData(group.filter(item => item !== undefined) || [])
      })
      .catch(_ => {})
  }, [])

  const submitHandler = values => {
    const obj = {
      id: id,
      deviceIdList: selectedDevices,
      defaultVerifyDevice: values?.defaultVerifyDevice?.map(item => item[1]),
    }
    console.log('obj', obj)
    updateConfigSite({ ...obj })
      .then(() => {
        form.resetFields()
        setSelectedDevices([])
        setDeviceList([])
        onOk()
        message.success(t('配置成功'))
      })
      .catch(_ => {})
  }

  let [deviceList, setDeviceList] = useState([])

  const preDeviceListData = data => {
    let arr = []
    for (const item of data) {
      let el = {
        name: item.device_type,
        device_id: item.device_type,
        device_list: item.device_list,
      }
      if (item.device_list) {
        for (let e of item.device_list) {
          e.device_type = item.device_type
          // e.device_name = `${e.device_name}`
          e.name = `${e.device_name}（${e.device_ip}）`
        }
      }
      arr.push(el)
    }
    return arr
  }

  const preVerifyDeviceListData = (data: any[], selectedDevices: string[]): DeviceItem[] => {
    // 获取当前选中的验证默认设备
    const currentSelectedDevices = form.getFieldValue('defaultVerifyDevice') || []
    // 获取第一个选中设备的 chainId
    const firstSelectedDevice = currentSelectedDevices[0]
    const firstSelectedDeviceId = firstSelectedDevice?.[1]

    // 从所有设备中查找第一个选中设备的完整信息
    let firstSelectedDeviceData = null
    for (const group of data) {
      if (group.device_list) {
        const device = group.device_list.find(d => d.device_id === firstSelectedDeviceId)
        if (device) {
          firstSelectedDeviceData = device
          break
        }
      }
    }
    const firstSelectedChainId = firstSelectedDeviceData?.chainId

    return data.map(item => {
      const deviceList = item.device_list?.map(device => {
        // 首先检查是否在关联安全设备中
        const isInSelectedDevices = selectedDevices.includes(device.device_id)

        // 如果有选中的设备，则检查 chainId 是否匹配
        let isChainIdMatch = true
        if (firstSelectedChainId) {
          isChainIdMatch = device.chainId === firstSelectedChainId
        }

        return {
          ...device,
          device_type: item.device_type,
          name: `${device.device_name}（${device.device_ip}）`,
          disabled: !isInSelectedDevices || !isChainIdMatch,
        }
      })

      // 如果该分组下有任何可选设备，则该分组可选
      const hasEnabledDevice = deviceList?.some(device => !device.disabled)

      return {
        name: item.device_type,
        device_id: item.device_type,
        device_list: deviceList,
        disabled: !hasEnabledDevice,
      }
    })
  }

  const onDeviceSelectChange = (value: any, selectedOptions) => {
    onDeviceSelect(value, selectedOptions)
    const deviceIds = value.map((v: any[]) => v[1]).filter(Boolean)
    setSelectedDevices(deviceIds)
  }

  const onDeviceSelect = (val, selectedOptions) => {
    let arr = selectedOptions?.map(el => el[1])
    setDeviceList(arr)
  }
  return (
    <DeviceModal
      onOk={form.submit}
      onCancel={onCancel}
      width={790}
      title={<BasTitle title={t('设备配置')} />}
      bodyStyle={{ height: 500, overflow: 'auto' }}
      centered
      visible
    >
      <Form form={form} onFinish={submitHandler} layout={'horizontal'} initialValues={{}}>
        <Form.Item
          name="deviceIdList"
          label={t('关联安全设备')}
          rules={[{ required: true, message: t('请选择关联安全设备') }]}
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 20 }}
        >
          <Cascader
            multiple
            maxTagCount="responsive"
            allowClear
            fieldNames={{
              label: 'name',
              value: 'device_id',
              children: 'device_list',
            }}
            style={{ width: '360px' }}
            options={preDeviceListData(deviceData)}
            onChange={(value: any, selectedOptions) => {
              onDeviceSelect(value, selectedOptions)
              // 只保存具体设备ID，不包含设备类型
              const deviceIds = value.map((v: any[]) => v[1]).filter(Boolean)
              setSelectedDevices(deviceIds)
              // 当关联安全设备变化时，清空验证默认设备的选择
              form.setFieldValue('defaultVerifyDevice', [])
            }}
            placeholder={t('请选择安全设备')}
            showCheckedStrategy={SHOW_CHILD}
          />
        </Form.Item>
        <Form.Item
          name="defaultVerifyDevice"
          label={t('验证默认设备')}
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 20 }}
        >
          <Cascader
            multiple
            maxTagCount="responsive"
            allowClear
            fieldNames={{
              label: 'name',
              value: 'device_id',
              children: 'device_list',
            }}
            style={{ width: '360px' }}
            options={preVerifyDeviceListData(deviceData, selectedDevices)}
            onChange={(value, selectedOptions) => {
              // 1. 获取所有可选 device_id
              const enabledDeviceIds: string[] = []
              preVerifyDeviceListData(deviceData, selectedDevices).forEach(group => {
                group.device_list?.forEach(device => {
                  if (!device.disabled) {
                    enabledDeviceIds.push(device.device_id)
                  }
                })
              })

              // 2. 过滤 value，只保留可选的 device_id
              const filteredValue = value.filter((v: any[]) => enabledDeviceIds.includes(v[1]))

              // 3. 设置过滤后的值
              form.setFieldValue('defaultVerifyDevice', filteredValue)

              // 4. 你原有的逻辑
              onDeviceSelect(filteredValue, selectedOptions)
            }}
            placeholder={t('请选择验证默认设备')}
            showCheckedStrategy={SHOW_CHILD}
          />
        </Form.Item>
      </Form>
    </DeviceModal>
  )
}

const DeviceModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
    position: relative;

    .ant-modal-close {
      width: 36px;
      height: 36px;
      background: #d8d6f4;
      box-shadow: -1px 4px 10px 0px #c7c7c7;
      border-radius: 6px;
      border: none;
      color: #4238c9;
      font-size: 16px;
      font-weight: 500;
      position: absolute;
      right: -8px;
      top: -8px;
      transition: transform 0.3s ease;

      &:hover {
        transform: translate(-18px, 18px);
        box-shadow: 0 0 0 0;
      }

      .ant-modal-close-x {
        width: 100%;
        height: 100%;
        line-height: 36px;
        text-align: center;
      }
    }

    .ant-modal-header {
      height: 56px;
      background: #f2f0ff;
      border-bottom: none;
      margin: 0;
    }
  }
`
